import { render } from "./TestimonialDashboard.vue?vue&type=template&id=85b98d94&scoped=true"
import script from "./TestimonialDashboard.vue?vue&type=script&lang=js"
export * from "./TestimonialDashboard.vue?vue&type=script&lang=js"

import "./TestimonialDashboard.vue?vue&type=style&index=0&id=85b98d94&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b98d94"]])

export default __exports__